export default "/images/a3184e04fa9d27247dc9f163058b689e.avif";